<template>
	<div>
		<BaseTabBar
			v-model="tabActiveAtIndex"
		>
			<CTab title="Opened issues">
				<!-- render when tab index equal 0 -->
				<ErrorOpenedIssue
					v-if="tabActiveAtIndex === 0"
				/>
			</CTab>
			<CTab title="Resolved issues">
				<!-- render when tab index equal 1 -->
				<ErrorResolvedIssue
					v-if="tabActiveAtIndex === 1"
				/>
			</CTab>
		</BaseTabBar>
	</div>
</template>

<script>
import { updateUrl } from '../helpers/mixins';

// Constant tabs, use with BaseTabBar component and  methods
const TABS = Object.freeze({
	0: 'opened-issues',
	1: 'resolved-issues',
});

export default {
	name: 'Errors',
	mixins: [updateUrl],
	data() {
		return {
			tabActiveAtIndex: this.getTabIndex(this.$route.query.tab),
			params: {
				tab: this.$route.query.tab,
			},
		};
	},
	watch: {
		tabActiveAtIndex() {
			this.params.tab = TABS[this.tabActiveAtIndex];
		},
		params: {
			handler() {
				this.updateUrl(this.params);
			},
			deep: true,
		},
	},
	methods: {
		getTabIndex(tabValue) {
			const index = Object.values(TABS).findIndex((value) => value === tabValue);

			return index === -1
				? 0 // default as 0
				: index;
		},
	},
};
</script>
